import {
  authReducer,
  orderReducer,
  basketReducer,
  errorsReducer,
  eventsReducer,
  initialReducer,
  profileReducer,
  documentsReducer,
  applicationReducer,
  attributionReducer,
  orderAnotherPersonReducer,
} from './slices';
import { migrations } from './migrations';
import storage from 'redux-persist/lib/storage';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { rtkQueryErrorLogger, emptyApi as api } from './api/emptyApi';
import { createMigrate, persistReducer, persistStore } from 'redux-persist';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2';

const rootPersistConfig = {
  storage,
  key: 'root',
  version: 26,
  autoMergeLevel2,
  keyPrefix: 'redux-',
  whitelist: ['basket', 'initial', 'order', 'events'],
  migrate: createMigrate(migrations, { debug: true }),
};

const rootReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  order: orderReducer,
  basket: basketReducer,
  errors: errorsReducer,
  events: eventsReducer,
  initial: initialReducer,
  profile: profileReducer,
  documents: documentsReducer,
  application: applicationReducer,
  attribution: attributionReducer,
  orderAnotherPerson: orderAnotherPersonReducer,
  auth: authReducer,
});

const store = configureStore({
  reducer: persistReducer(rootPersistConfig, rootReducer),

  middleware: (getDefault) =>
    getDefault({ serializableCheck: false, immutableCheck: false }).concat(rtkQueryErrorLogger).concat(api.middleware),
});

persistStore(store);
// persistor.purge(); // Clear persisted state

export default store;

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof rootReducer>;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
